require("./bootstrap");

// admin-lte
require("admin-lte");

//CkEditor
require("@ckeditor/ckeditor5-build-classic");

//CkEditor
$(function () {
    //on page ready
    let editor = document.querySelector("#editor");
    if (editor !== null) {
        window.ClassicEditor = require("@ckeditor/ckeditor5-build-classic")
            .create(editor)
            .catch((error) => {
                // console.error( error );
            });
    }
});

//jQuery
// import jQuery from 'jquery';
// window.$ = jQuery;
// import $ from "jquery";

import $ from "jquery";
import "select2";
import "select2/dist/css/select2.min.css";

// Optional: If using Bootstrap 4/5 theme
import "@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css";

$(document).ready(function () {
    $(".select2").select2();
});
